import { useEffect, useMemo, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Header } from "../../Components/Index";
import { useService } from "../../Context/ServiceContext";
import ReceiptHero from "./components/ReceiptHero";
import ReceiptItems from "./components/ReceiptItems";
import ReceiptVehicle from "./components/ReceiptVehicle";
import ReceiptIcon from "./components/ReceiptIcon";

export default function ServiceThree() {
  const location = useLocation();
  const navigate = useNavigate();
  const { resetService } = useService();
  const [shareMessage, setShareMessage] = useState("");
  const serviceData = location.state?.serviceData || null;

  useEffect(() => {
    if (!serviceData) navigate("/PlateCapture", { replace: true });
  }, [navigate, serviceData]);

  useEffect(() => {
    if (serviceData) resetService();
  }, [resetService, serviceData]);

  const services = useMemo(() => serviceData?.categories || [], [serviceData]);
  const totalCost = useMemo(
    () => services.reduce((sum, item) => sum + (Number(item.cost) || 0), 0),
    [services]
  );

  if (!serviceData) return null;

  const shareReceipt = async () => {
    const vehicleName = serviceData.vehicle?.title || serviceData.vehicle?.brand || "خودرو";
    const serviceLines = services.map((item, index) => `${index + 1}. ${item.title}${item.action ? ` (${item.action === "L" ? "تعویض" : item.action === "R" ? "بازدید" : item.action})` : ""}`).join("\n");
    const text = [
      "رسید سرویس خودرو",
      `شماره رسید: ${serviceData.id}`,
      `خودرو: ${vehicleName}`,
      `کارکرد: ${Number(serviceData.mileage || 0).toLocaleString("fa-IR")} کیلومتر`,
      "",
      "سرویس‌های انجام‌شده:",
      serviceLines,
      "",
      `جمع هزینه: ${totalCost ? `${totalCost.toLocaleString("fa-IR")} ریال` : "ثبت نشده"}`,
    ].join("\n");
    try {
      if (navigator.share) {
        await navigator.share({ title: `رسید سرویس ${vehicleName}`, text });
        setShareMessage("رسید با موفقیت برای اشتراک‌گذاری آماده شد");
      } else if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(text);
        setShareMessage("متن کامل رسید کپی شد؛ اکنون می‌توانید آن را ارسال کنید");
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed";
        textArea.style.opacity = "0";
        document.body.appendChild(textArea);
        textArea.select();
        const copied = document.execCommand("copy");
        textArea.remove();
        setShareMessage(copied ? "متن کامل رسید کپی شد؛ اکنون می‌توانید آن را ارسال کنید" : "امکان اشتراک‌گذاری در این مرورگر وجود ندارد");
      }
    } catch (error) {
      if (error?.name !== "AbortError") setShareMessage("اشتراک‌گذاری انجام نشد");
    }
  };

  return <>
    <Header Text="رسید سرویس" hideR="" LinkR="/ServiceDashbord" showNotification={false} />
    <main className="service-receipt" dir="rtl">
      <ReceiptHero serviceId={serviceData.id} serviceDate={serviceData.serviceDate} count={services.length} />
      <ReceiptVehicle vehicle={serviceData.vehicle} customer={serviceData.customer} mileage={serviceData.mileage} />
      <ReceiptItems services={services} totalCost={totalCost} />

      <footer className="service-receipt__footer">
        <button type="button" onClick={shareReceipt}><ReceiptIcon name="share" />اشتراک‌گذاری رسید</button>
        <Link to="/ServiceDashbord" className="is-secondary"><ReceiptIcon name="dashboard" />بازگشت به داشبورد سرویس‌کار</Link>
      </footer>
      {shareMessage && <p className="service-receipt__message" role="status" aria-live="polite">{shareMessage}</p>}
    </main>
  </>;
}
